import {
  Box,
  Container,
  Grid,
  Paper,
  Typography,
} from "@mui/material";
import Header from "../Header.tsx";
import Footer from "../Footer.tsx";
import "../../styles/layouts.scss";
import { useTranslation } from "react-i18next";

const VISUALIZE__URL = import.meta.env.VITE_VISUALIZE__URL;

//images
const subscribe = VISUALIZE__URL + "freetrail_bg.webp";
const aboutvideo = VISUALIZE__URL + "about_video.webp";
const medicalconcepts = VISUALIZE__URL + "demo_vertical_video.mp4";
const mission = VISUALIZE__URL + "mission.webp";
const core = VISUALIZE__URL + "value.webp";
const vission = VISUALIZE__URL + "shared-vision.webp";

const PreloginAboutUs = () => {
  const { t } = useTranslation();
  return (
    <>
      <Header />
      <Box
        className="service_main"
        sx={{
          backgroundImage: `url(${subscribe})`,
          zIndex: -1,
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)", // Dark overlay with 50% opacity
            zIndex: -1, // Places it above the background but below the content
          },
        }}
      >
        <Typography
          className="atitle"
          variant="h4"
          fontWeight="bold"
          sx={{ mb: 1, fontSize: "38px", textTransform: "uppercase" }}
        >
          {t("about_us")}
        </Typography>

        {/* <Typography variant="subtitle1" sx={{ mb: 3, fontSize: "16px" }}>Home / About Us</Typography> */}
      </Box>

      {/* ==================== SECTION: VIDEO SHOWCASE ==================== */}
      <Container className="about_container" maxWidth="lg" sx={{ mt: -10 }}>
        <Paper
          className="aboutpaper"
          elevation={3}
          sx={{
            position: "relative",
            width: "100%",
            height: "400px",
            borderRadius: "25px",
            overflow: "hidden",
          }}
        >
          <Box
            className="about_img"
            component="img"
            src={aboutvideo}
            alt="Medical Animation Studio"
            sx={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "rgba(0,0,0,0.3)",
            }}
          >
          </Box>
        </Paper>
      </Container>

      {/* ==================== SECTION: MISSION STATEMENT ==================== */}
      <Container maxWidth="lg">
        <Box
          className="aboutcontainer1"
          sx={{ textAlign: "center", mb: 6, mt: 4 }}
        >
          <Typography
            className="aboutcontent"
            variant="body1"
            sx={{ mb: 4, px: 4, fontSize: "18px" }}
          >
            {t("about_us_description")}
          </Typography>
          <Box
            sx={{ width: "100%", height: "1px", bgcolor: "#e0e0e0", my: 4 }}
          />
        </Box>

        {/* ==================== SECTION: WHO WE ARE ==================== */}
        <Grid container spacing={4} sx={{ mb: 8 }}>
          <Grid item xs={12} md={5} className="aboutvideo">
            <Box
              className="video"
              sx={{
                width: "100%",
                aspectRatio: "5.8 / 9",
                height: "auto",
                borderRadius: "10px",
                boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                overflow: "hidden", // Prevents overflow issues
              }}
            >
              <video
                autoPlay
                muted
                loop
                playsInline
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  borderRadius: "10px",
                  display: "block",
                }}
              >
                <source src={medicalconcepts} type="video/mp4" />
                {t("your_browser_does_not_support_the_video_tag.")}
              </video>
            </Box>
          </Grid>
          <Grid item xs={12} md={7}>
            <Box sx={{ pl: { md: 4 } }} className="aboutvideocontent">
              <Typography
                className="subtitle"
                variant="subtitle2"
                color="black"
                fontWeight="bold"
                fontSize={"18px"}
              >
                {t("our_history")}
              </Typography>
              <Typography
                className="title1"
                variant="h4"
                fontWeight="bold"
                color="#0080ff"
                fontSize={"28px"}
                lineHeight={1.5}
                sx={{ mb: 2 }}
              >
                {t("bringing_complex")}
              </Typography>
              <Typography
                className="history"
                variant="body1"
                fontSize={"18px"}
                textAlign="justify"
                sx={{ mb: 2 }}
              >
                {t("about_us_longdescription1")}

                <br className="responsive-break" />
                {t("about_us_longdescription2")}
              </Typography>

              
            </Box>
          </Grid>
        </Grid>

        {/* ==================== SECTION: OUR VALUES ==================== */}
        <Box sx={{ mb: 8 }}>
          <Typography
            className="purpose"
            variant="subtitle2"
            fontWeight="bold"
            color="black"
            textAlign="center"
            fontSize={"18px"}
            sx={{ mb: 1 }}
          >
            {t("out_purpose_and_commit")}
            {/* Our Purpose and Commitment */}
          </Typography>
          <Typography
            className="info"
            variant="h5"
            fontWeight="bold"
            color="#0080ff"
            textAlign="center"
            fontSize={"28px"}
            sx={{ mb: 5 }}
          >
            {t("transforming_healthcare_communication")}
            {/* Transforming Healthcare Communication{" "} */}
            <br className="resposive-break" />
            {t("with_clarity_and_precision")}
            {/* with Clarity and Precision */}
          </Typography>

          <Grid container spacing={4}>
            <Grid item xs={12} md={4}>
              <Box
                sx={{
                  p: 3,
                  height: "100%",
                  background: "#F9F9F9", // Updated background color
                  borderRadius: "25px",
                  boxShadow: "0px 1px 4px 0px #00000040",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  textAlign: "center",
                }}
              >
                <Box
                  sx={{
                    width: 60,
                    height: 60,
                    borderRadius: "50%",
                    bgcolor: "#1976D2",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mb: 2,
                  }}
                >
                  <Typography variant="h5" color="white">
                    <img
                      src={mission}
                      alt="icon"
                      style={{ width: 50, height: 20, marginLeft: 1 }}
                    />
                  </Typography>
                </Box>
                <Typography
                  variant="h6"
                  fontWeight="bold"
                  color="#0080ff"
                  sx={{ mb: 2 }}
                >
                  {t("our_mission")}
                  {/* Our Mission */}
                </Typography>
                <Typography
                  variant="body2"
                  textAlign={"left"}
                  fontSize={"16px"}
                >
                  {t("our_mission_description")}
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12} md={4}>
              <Box
                sx={{
                  p: 3,
                  height: "100%",
                  background: "#F9F9F9", // Updated background color
                  borderRadius: "25px",
                  boxShadow: "0px 1px 4px 0px #00000040",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  textAlign: "center",
                }}
              >
                <Box
                  sx={{
                    width: 60,
                    height: 60,
                    borderRadius: "50%",
                    bgcolor: "#1976D2",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mb: 2,
                  }}
                >
                  <Typography variant="h5" color="white">
                    <img
                      src={vission}
                      alt="icon"
                      style={{ width: 50, height: 20, marginLeft: 1 }}
                    />
                  </Typography>
                </Box>
                <Typography
                  variant="h6"
                  fontWeight="bold"
                  color="#0080ff"
                  sx={{ mb: 2 }}
                >
                  {t("our_vision")}
                  {/* Our Vision */}
                </Typography>
                <Typography
                  variant="body2"
                  textAlign={"left"}
                  fontSize={"16px"}
                >
                  {t("our_vision_description")}
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12} md={4}>
              <Box
                sx={{
                  p: 3,
                  height: "100%",
                  background: "#F9F9F9", // Updated background color
                  borderRadius: "25px",
                  boxShadow: "0px 1px 4px 0px #00000040",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  textAlign: "center",
                }}
              >
                <Box
                  sx={{
                    width: 60,
                    height: 60,
                    borderRadius: "50%",
                    bgcolor: "#1976D2",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mb: 2,
                  }}
                >
                  <Typography variant="h5" color="white">
                    <img
                      src={core}
                      alt="icon"
                      style={{ width: 50, height: 20, marginLeft: 1 }}
                    />
                  </Typography>
                </Box>
                <Typography
                  variant="h6"
                  fontWeight="bold"
                  color="#0080ff"
                  sx={{ mb: 2 }}
                >
                  {t("core_vaues")}
                  {/* Core Values */}
                </Typography>
                <Typography
                  variant="body2"
                  textAlign={"left"}
                  fontSize={"16px"}
                >
                  {t("core_vaues_description")}
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Container>
      <Footer />
    </>
  );
};
export default PreloginAboutUs;
